import { createReducer, on } from '@ngrx/store';
import {
	IGqlMassMessages,
	IMassMessage,
	IMessageText,
} from '../interfaces/messages.interfaces';
import {
	addMessage,
	clearMessages,
	clearViewMessage,
	handlePaginatedData,
	setMessageExternalDate,
	openNewMessage,
	setIsLoading,
	setMessages,
	setPaginationOptions,
	setViewMessage,
	clearMessageExternalDate,
} from './messages.action';
import { LocationTypes } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import {
	IAuPaginationData,
	IDjangoPaginationData,
} from '@app/shared/ui-components/au-paginator/pagination-page.info';
import { IUser } from '@app/shared/interfaces/user.interface';

export interface IMessagesState {
	allMessages: IGqlMassMessages[];
	currentBuilding: {
		name: string;
		locationId: string;
		locationType: LocationTypes;
	} | null;
	messagesIsLoading: boolean;
	messagesPagination: IDjangoPaginationData | null;
	paginationOptions: IAuPaginationData | null;
	viewMessage: IGqlMassMessages;
	messageText: IMessageText;
}

export const initialState: IMessagesState = {
	allMessages: [],
	currentBuilding: null,
	messagesIsLoading: true,
	messagesPagination: null,
	paginationOptions: null,
	viewMessage: null,
	messageText: {
		recipients: null,
		subject: null,
		text: null,
		files: null,
	},
};

export function setMessagesFn(
	state: IMessagesState,
	{
		messages,
		messagesPagination,
	}: { messages: IGqlMassMessages[]; messagesPagination: IDjangoPaginationData }
): IMessagesState {
	return {
		...state,
		allMessages: messages,
		messagesIsLoading: false,
		messagesPagination: messagesPagination,
	};
}

export function addMessageFn(
	state: IMessagesState,
	{ messages, currentUser }: { messages: IMassMessage; currentUser: IUser }
): IMessagesState {
	const newMessage: IGqlMassMessages = {
		subject: messages.subject,
		recipients: messages.recipients,
		createdBy: currentUser,
		text: messages.text,
		created: new Date(),
		attachments: messages.files?.map(file => ({
			pk: file.pk,
			name: file.name,
		})),
	};

	return {
		...state,
		allMessages: [newMessage, ...state.allMessages],
	};
}

export const messagesReducer = createReducer(
	initialState,
	on(addMessage, addMessageFn),
	on(setMessages, setMessagesFn),
	on(clearMessages, state => ({
		...state,
		allMessages: [],
		messagesIsLoading: true,
	})),

	on(setPaginationOptions, (state, { paginationOptions }) => ({
		...state,
		paginationOptions: paginationOptions,
	})),

	on(handlePaginatedData, (state, { paginatedData }) => ({
		...state,
		messagesPagination: paginatedData.messagesPagination,
		allMessages: paginatedData.messages,
		messagesIsLoading: false,
	})),

	on(setIsLoading, (state, { isLoading }) => ({
		...state,
		messagesIsLoading: isLoading,
	})),

	on(setViewMessage, (state, { viewMessage }) => ({
		...state,
		viewMessage: viewMessage,
	})),

	on(clearViewMessage, state => ({
		...state,
		viewMessage: null,
	})),

	on(openNewMessage, state => ({
		...state,
	})),
	on(setMessageExternalDate, (state, { messageText }) => ({
		...state,
		messageText: messageText,
	})),
	on(clearMessageExternalDate, state => ({
		...state,
		messageText: {
			recipients: null,
			subject: null,
			text: null,
			files: null,
		},
	}))
);
